import { createStyles, makeStyles } from '@material-ui/core';
import { Button, ExtendedTheme, ProgressBar, TextBlock } from 'neon-design-system';
import React from 'react';

interface FetchMorePaginator {
	fetchMore: () => void;
	label: string;
	showingCurrent: number;
	totalCount: number;
	hasNextPage: boolean;
	displayShowMoreButton: boolean;
	displayCount?: boolean;
}

const useStyles = makeStyles<ExtendedTheme>((theme: ExtendedTheme) => createStyles({
	root: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center'
	},
	label: {
		color: theme.themeColors.grey[400]
	},
	progressBar: {
		width: 120,
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(2)
	}
}));

const FetchMorePaginator = ({
	fetchMore,
	label,
	showingCurrent,
	totalCount,
	hasNextPage,
	displayShowMoreButton = true,
	displayCount = true
}: FetchMorePaginator) => {
	const classes = useStyles();
	return (
		<div className={classes.root}>
			{
				displayCount
					?
					<TextBlock
						className={[classes.label, 'showingArticlesNumber'].join(' ')}
						styleName="footnote">
						Showing {showingCurrent} of {totalCount} {label}
					</TextBlock>
					: null
			}
			{hasNextPage &&
				<>
					<ProgressBar className={[classes.progressBar, 'progressBar'].join(' ')} indicator={showingCurrent} limit={totalCount} />
					{displayShowMoreButton
						? <Button
							className="showMoreArticlesButton"
							colorType="primary"
							onClick={fetchMore}>
							Show more {label}
						</Button>
						: null}
				</>}
		</div>
	);
};

export default FetchMorePaginator;
